module.exports = __webpack_public_path__ + "img/ep-carre-coins-casses.af64c62b.jpg";